import React, { useEffect, useRef } from "react";
import NotificationBar from "../notification-bar";
import { useIsSticky } from "../../shared/hooks";
import { sampleProductText } from "shared/digital-content";
import { useLastOpenedTask } from "shared/hooks/api";
import { linkedProductMessage } from "shared/banner-info";

const TaskNav = (props) => {
    const refTaskSticky = useRef();
    const postLastVisitedTask = useLastOpenedTask();
    const isSticky = useIsSticky(refTaskSticky);
    const wrapperClass = isSticky ? "-expand" : "";
    const taskNavClass = isSticky ? "task-nav -fixed" : "task-nav";

    useEffect(() => {
        // Set Last Opened
        if (props.taskKey) {
            postLastVisitedTask(props.taskKey);
        }
    }, []);

    return (
        <>
            <div ref={refTaskSticky}></div>
            <div className={wrapperClass} id="task-nav-wrapper">
                <div className={taskNavClass}>{props.children}</div>
                {props.isSampleProduct && <NotificationBar message={sampleProductText} type="info" />}
            </div>
            <div className={wrapperClass} id="task-nav-wrapper">
                {props.linkedTaskContextKey && <NotificationBar message={linkedProductMessage} type="info" />}
            </div>
        </>
    );
};

TaskNav.defaultProps = {
    fixAfter: 98,
};

export default TaskNav;
